import { CustomHeading } from 'components'
import { Images } from 'constants'
import React, { useEffect } from 'react'

const Celebrity = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="p-1 flex justify-center items-center">
            <div>
                <CustomHeading
                    svg={false}
                    text="Celebrity With Us"
                    down_icon={true}
                    redirect={false}
                    type={1}
                />

                <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 mt-2 mx-1">
                    {[Images.CELEBRITY_1, Images.CELEBRITY_2, Images.CELEBRITY_3, Images.CELEBRITY_4].map((item, index) => (
                        <div key={index}
                            className="rounded-lg w-full h-[100px] overflow-hidden shadow-md mx-auto"
                        >
                            <img
                                src={item}
                                alt={`Thumbnail`}
                                className="w-full h-full object- rounded-lg"
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default Celebrity